import type { ServiceTypeEnum } from "../../../Enums/FirmEnum";

export type FirmPhoneNumber = {
  code: string;
  phone: string;
  basecode: string;
};

export type GeoSelection = { id: string; name: string };

export const EMPTY_PHONE_NUMBER: FirmPhoneNumber = {
  code: "",
  phone: "",
  basecode: "",
};

export type CreateFirmFormState = {
  firmName: string;
  displayName: string;
  serviceType: ServiceTypeEnum | "";
  country: GeoSelection;
  state: string;
  /** States catalog id when the state was picked from the dropdown. */
  stateId: string;
  /** States catalog abbreviation when the state was picked from the dropdown. */
  stateAbbreviation: string;
  city: string;
  address1: string;
  address2: string;
  zipCode: string;
  logo: string | File | null;
  phoneNumber: FirmPhoneNumber;
  websiteUrl: string;
  yearFounded: string;
  acceptedEmailDomain: string[];
  firmOverview: string;
  totalProfessionals: string;
  professionalsInPrimary: string;
};

export const INITIAL_CREATE_FIRM_FORM: CreateFirmFormState = {
  firmName: "",
  displayName: "",
  serviceType: "",
  country: { id: "", name: "" },
  state: "",
  stateId: "",
  stateAbbreviation: "",
  city: "",
  address1: "",
  address2: "",
  zipCode: "",
  logo: null,
  phoneNumber: { ...EMPTY_PHONE_NUMBER },
  websiteUrl: "",
  yearFounded: "",
  acceptedEmailDomain: [],
  firmOverview: "",
  totalProfessionals: "",
  professionalsInPrimary: "",
};

export type CreateFirmFieldErrors = Partial<
  Record<keyof CreateFirmFormState | "jurisdiction", string>
>;
